/**
 * Resolve API base URL for fetch calls.
 *
 * - When VITE_API_BASE_URL is set at build time, use it.
 * - Otherwise use same-origin relative paths so nginx on :3310 proxies /api → backend.
 *   (Avoids hardcoding localhost:8000 which is wrong in Docker; backend is on :8810 or internal.)
 */
export function getApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_BASE_URL
  if (envUrl && typeof envUrl === 'string' && envUrl.trim() !== '') {
    return envUrl.replace(/\/$/, '')
  }
  return ''
}

export function apiUrl(path: string): string {
  const base = getApiBaseUrl()
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return base ? `${base}${normalizedPath}` : normalizedPath
}
